import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function LaunchQRModal() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("launch") === "true") {
      setShow(true);
      window.history.replaceState({}, "", "/");
    }
  }, []);

  if (!show || typeof document === "undefined") return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={() => setShow(false)}
    >
      <div
        className="relative bg-white rounded-2xl shadow-2xl max-w-sm w-[88%] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-purple-600 px-4 py-3 flex items-center gap-2">
          <img
            src="/images/whitelogo.svg"
            alt="Tringbox"
            className="w-8 h-8 flex-shrink-0"
          />
          <div className="text-white min-w-0 flex-1">
            <h2 className="font-bold text-base leading-tight m-0">Tringbox Partner App</h2>
            <p className="text-purple-200 text-xs m-0 whitespace-nowrap">Apply for Gigs · Showcase Talent · Earn</p>
          </div>
          <button
            onClick={() => setShow(false)}
            className="text-white/80 hover:text-white transition-colors p-0 bg-transparent border-none"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="px-4 py-4 text-center">
          <p className="text-gray-600 text-xs mb-3 m-0">
            Get discovered by event organisers, apply for gigs near you, and earn by performing at events.
          </p>

          {/* QR Code */}
          <div className="border border-purple-100 rounded-lg p-3 inline-block">
            <p className="text-purple-600 font-semibold text-xs mb-1 m-0">📱 Scan to download</p>
            <img
              src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https%3A%2F%2Fpartner.tringbox.com%2Flaunch&margin=4"
              alt="QR Code to download Tringbox Partner App"
              className="w-40 h-40 mx-auto"
            />
          </div>

          {/* Divider */}
          <div className="flex items-center gap-2 my-3 max-w-[240px] mx-auto">
            <div className="flex-1 h-px bg-gray-200" />
            <span className="text-[10px] text-gray-400 uppercase tracking-wide">Or download from</span>
            <div className="flex-1 h-px bg-gray-200" />
          </div>

          {/* Store buttons */}
          <div className="flex gap-2 max-w-[260px] mx-auto">
            <a
              href="https://play.google.com/store/apps/details?id=com.tringbox.tringdj"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 bg-purple-600 hover:bg-purple-700 text-white rounded-lg py-2 px-3 flex items-center justify-center gap-1.5 transition-colors text-xs font-medium no-underline whitespace-nowrap"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current flex-shrink-0">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
              </svg>
              Google Play
            </a>
            <a
              href="https://apps.apple.com/in/app/tringbox-partner/id6753770166?l=mr"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 bg-purple-600 hover:bg-purple-700 text-white rounded-lg py-2 px-3 flex items-center justify-center gap-1.5 transition-colors text-xs font-medium no-underline whitespace-nowrap"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current flex-shrink-0">
                <path d="M18.71,19.5C17.88,20.5 17,21.4 15.66,21.41C14.32,21.43 13.89,20.6 12.37,20.6C10.84,20.6 10.37,21.38 9.1,21.43C7.79,21.48 6.8,20.43 5.96,19.47C4.25,17.5 2.94,13.87 4.72,11.42C5.57,10.19 6.94,9.44 8.41,9.42C9.68,9.4 10.85,10.3 11.62,10.3C12.38,10.3 13.8,9.22 15.33,9.38C15.97,9.41 17.54,9.65 18.54,11.11C18.45,11.17 16.55,12.26 16.57,14.55C16.6,17.29 19.05,18.21 19.08,18.22L18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.09,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
              </svg>
              App Store
            </a>
          </div>

          <p className="text-[10px] text-gray-400 mt-2 m-0">
            Free on Android & iOS · No sign-up required to browse
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
}
